<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: "app",
};
</script>

<style lang="scss">
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/css/font-awesome.min.css";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/css/simple-line-icons.css";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "../src/style/common/coreui/style";
/* Import Custom Settings */
// Import Global Settings
@import "../src/style/common/global.scss";
@import "../src/style/common/font.css";
// @import "~jsoneditor/dist/jsoneditor.css";
</style>
